import { Loader, ModeSwitch, SideNav, TopNav } from "components";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ModeState, changeMode, logUserIn } from "services/redux/site";
import { AppDispatch, RootState } from "services/redux/store";

import { ThemeProvider } from "@mui/material/styles";
import { Avatar } from "@mui/material";
import { logo } from "utils/assets_exports/images";
import { addAllNoti } from "services/redux/notifications";
import { notiData } from "assets/data/notiData";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getTheme } from "utils/helpers/getTheme";

const RootLayout = () => {
    const { mode, isLoggedIn } = useSelector((state: RootState) => state.site);

    const dispatch = useDispatch<AppDispatch>();
    const modeCk = Cookies.get("mode");

    useEffect(() => {
        if (!modeCk) {
            Cookies.set("mode", mode, { expires: 365 });
        } else {
            dispatch(changeMode(modeCk as ModeState));
        }
    }, []);

    const pathName = useLocation().pathname;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const loginCookie = Cookies.get("logedIn");

    useEffect(() => {
        if (!isLoggedIn && pathName != "/login") {
            if (loginCookie == undefined || loginCookie == "false") {
                navigate("/login");
            } else {
                dispatch(logUserIn());
                dispatch(addAllNoti(notiData));
            }
        }
        setLoading(false);
    }, [isLoggedIn]);

    const theme = getTheme(mode);

    return (
        <div className={`App ${mode} h-screen box-layout`}>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                // theme={mode}
                // transition:"Bounce"
            />
            <ThemeProvider theme={theme}>
                {loading ? (
                    <div className="flex justify-center items-center h-full w-full bg-neutral-50 dark:bg-momeento-100">
                        <Loader />
                    </div>
                ) : (
                    <div className="xl:py-10 h-full">
                        <div className="xl:container xl:mx-auto xl:rounded bg-neutral-50 h-full overflow-hidden">
                            <div className="flex flex-row w-full h-full">
                                {isLoggedIn ? <SideNav /> : ""}
                                <div className="flex flex-col w-full h-full overflow-hidden">
                                    {isLoggedIn ? (
                                        <TopNav />
                                    ) : (
                                        <div className="shadow-xl bg-white dark:bg-momeento-400">
                                            <div className="flex flex-row justify-between items-center px-4 py-2 gap-4">
                                                <div
                                                    style={{ width: 50 }}
                                                ></div>
                                                <Avatar
                                                    alt="text"
                                                    src={logo}
                                                    className="cursor-pointer"
                                                />
                                                <ModeSwitch />
                                            </div>
                                        </div>
                                    )}
                                    <div className="overflow-auto w-full h-full bg-neutral-50 dark:bg-momeento-100">
                                        <Outlet />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </ThemeProvider>
        </div>
    );
};

export default RootLayout;
